import React from 'react';
import {
  TextCollectionAttachment,
  TextCollectionAttachmentType,
} from '@scale/shared/types/params/textcollection';
import AudioAttachmentView from './AudioAttachmentView';

// is there a way to coordinate this with the type check below? if it's a union type??
export const ALLOWED_INLINE_ATTACHMENT_TYPES = [TextCollectionAttachmentType.Audio];

interface InlineFormAttachmentViewProps {
  attachment: TextCollectionAttachment;
  markAttachmentAsCompleted: (isComplete: boolean) => void;
  completed: boolean;
}

const InlineFormAttachmentView: React.FC<InlineFormAttachmentViewProps> = props => {
  const attachmentContentsByType = () => {
    if (props.attachment.type === TextCollectionAttachmentType.Audio) {
      return (
        <AudioAttachmentView
          attachment={props.attachment}
          completed={props.completed}
          markAttachmentAsCompleted={props.markAttachmentAsCompleted}
          isInline
        />
      );
    }
    return null;
  };
  return <div>{attachmentContentsByType()}</div>;
};

export default InlineFormAttachmentView;
